import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { blinkBorderAnimation } from 'src/app/animations/blink';
import { EventDetailComponent } from '../../event-detail/event-detail.component';

@Component({
  selector: 'app-event-live-detail-mobile',
  templateUrl: './event-live-detail-mobile.component.html',
  styleUrls: ['./event-live-detail-mobile.component.less'],
  animations: [blinkBorderAnimation],
  encapsulation: ViewEncapsulation.None
})
export class EventLiveDetailMobileComponent extends EventDetailComponent implements OnInit{
  ngOnInit() {
    super.ngOnInit();
    this.isLive = true;
    this.isMobileView = true;
  }

  // showTitle(event){
  //   // console.log(event.target.attributes.title.value);
  //   // const description = event.target.nextSibling;
  //   if (event.currentTarget.children.length === 1) {
  //     const newSpan = document.createElement('span');
  //     newSpan.className = 'description-title show';
  //     newSpan.innerText = event.currentTarget.attributes.title.value;
  //     const width = window.outerWidth - event.x - 15;
  //     document.querySelectorAll('.description-title').forEach(e => e.remove());
  //     event.currentTarget.append(newSpan);

  //   } else {
  //     document.querySelectorAll('.description-title').forEach(e => e.remove());
  //   }

  //   // if (!description.className.match('show')) {
  //   //   const width = window.outerWidth - event.x - 15;

  //   //   description.innerText = event.target.attributes.title.value;
  //   //   description.style.width = width + 'px';
  //   //   document.querySelectorAll('.description-title').forEach(e => e.classList.remove('show'));
  //   //   description.classList.toggle('show');

  //   // } else {
  //   //   document.querySelectorAll('.description-title').forEach(e => e.classList.remove('show'));

  //   // }


  // }
}
